/**
 * Hook pour la navigation vers les modules
 */
import { useNavigate } from 'react-router-dom'
import { MODULE_ROUTES, TASKBAR_ROUTES } from '@/constants/landing/routes.constants'

export function useModuleNavigation() {
  const navigate = useNavigate()

  const navigateToModule = (moduleId: string) => {
    const route = MODULE_ROUTES[moduleId]
    if (route) {
      navigate(route)
    } else {
      console.warn(`Route not found for module: ${moduleId}`)
    }
  }

  const navigateToTaskBar = (moduleId: string) => {
    const route = TASKBAR_ROUTES[moduleId]
    if (route) {
      navigate(route)
    } else {
      // Pour les modules de la taskbar qui n'ont pas encore de route
      console.log(`${moduleId} clicked - TODO: Implement route`)
    }
  }

  return {
    navigateToModule,
    navigateToTaskBar
  }
}

